import React from 'react';

const BacklogSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000.000000 1500.000000"
      {...props}
    >
      <g
        transform="translate(0.000000,940.000000) scale(0.100000,-0.100000)"
        fillOpacity='0'
        stroke='currentColor'
        strokeWidth='200'
      >
        <path d="M2865 8854 c-232 -18 -492 -56 -705 -104 -210 -47 -585 -164 -731 -229 -44 -20 -42 -20 1681 -20 1723 0 1725 0 1681 20 -88 39 -319 118 -476 162 -261 74 -497 122 -755 152 -128 15 -583 28 -695 19z" />
        <path d="M1200 8270 l0 -160 1910 0 1910 0 0 160 0 160 -1910 0 -1910 0 0 -160z" />
        <path d="M1360 7075 l0 -945 1750 0 1750 0 0 945 0 945 -1750 0 -1750 0 0 -945z" />
        <path d="M1200 5880 l0 -160 1910 0 1910 0 0 160 0 160 -1910 0 -1910 0 0 -160z" />
        <path d="M1386 5631 c14 -13 292 -114 427 -155 977 -296 1891 -267 2862 91 83 30 154 59 160 64 5 5 -708 9 -1725 9 -1017 0 -1730 -4 -1724 -9z" />
        <path d="M1829 5346 c0 0 -202 -1139 -447 -2531 l-447 -2530 257 -3 258 -2 832 659 c711 565 834 658 848 648 9 -7 384 -303 832 -659 l816 -648 253 0 252 0 -6 43 c-7 49 -874 4972 -882 5003 l-5 21 -107 -23 c-153 -32 -324 -61 -497 -84 l-150 -19 -263 -263 -263 -263 -263 263 -263 263 -150 19 c-173 22 -344 52 -496 84 -60 13 -108 23 -109 22z m554 -1378 c-227 -227 -414 -410 -416 -408 -3 3 51 318 119 700 68 382 123 697 124 700 0 3 132 -127 292 -288 l293 -292 -412 -412z m1752 290 c67 -381 120 -695 118 -698 -2 -2 -189 181 -416 408 l-412 412 290 290 c159 159 291 287 293 285 3 -2 60 -316 127 -697z m-600 -618 l420 -420 -845 0 -845 0 420 420 c231 231 422 420 425 420 3 0 194 -189 425 -420z m333 -869 c-3 -9 -746 -601 -754 -601 -4 0 -731 575 -754 596 -12 12 99 14 749 14 448 0 761 -4 759 -9z m-1575 -520 c251 -199 457 -365 456 -369 0 -7 -1252 -1001 -1256 -998 -2 2 291 1672 303 1729 5 25 8 27 22 14 10 -8 223 -177 475 -376z m2283 -493 c83 -475 151 -864 150 -865 -5 -6 -1245 984 -1242 992 4 14 928 746 934 740 3 -3 74 -393 158 -867z" />
      </g>
    </svg>
  );
};

export { BacklogSVG };